<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" v-for="(item, i) in form" :key="i">
        <v-select
          :label="item.label"
          v-model="item.value"
          outlined
          v-if="item.type == 'select'"
          :rules="item.rules"
          :type="item.type"
          :dense="$root.dense"
          :items="roles"
          item-text="name"
          item-value="value"
          :disabled="item.disabled"
          @change="input"
        >
        </v-select>
        <v-text-field
          :label="item.label"
          v-model="item.value"
          outlined
          :rules="item.rules"
          :type="item.type"
          :dense="$root.dense"
          :disabled="item.disabled"
          :max="item.counter"
          v-else
          :counter="item.counter"
          @input="input"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { roles } from "../../../assets/js/default";
import { FIELD } from "../../../assets/js/rules";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      phone: [
        (v) => !!v || "Please enter a valid US Phone number",
        (v) => v.length == 10 || "Please enter a valid US Phone number",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      rules: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 255 || "Field must be less than 255 characters",
      ],
    };
  },
  computed: {
    roles() {
      return roles;
    },
    isUpdate() {
      return this.$route.name === "user-update";
    },
    form: {
      get() {
        let { first_name, last_name, email, phone, role } = this.value;
        console.log(role);
        let form = [
          {
            value: first_name,
            key: "first_name",
            label: "First Name",
            rules: this.rules,
            disabled: false,
            type: "text",
            counter: 255,
          },
          {
            value: last_name,
            key: "last_name",
            label: "Last Name",
            disabled: false,
            rules: this.rules,
            type: "text",
            counter: 255,
          },
          {
            value: email,
            key: "email",
            label: "Email",
            disabled: this.isUpdate,
            rules: this.emailRules,
            type: "text",
            counter: 255,
          },
          {
            value: phone,
            key: "phone",
            disabled: false,
            label: "Phone",
            rules: this.phone,
            type: "number",
            counter: 10,
          },
          {
            value: role,
            key: "role",
            disabled: false,
            label: "Role",
            rules: FIELD,
            type: "select",
          },
        ];
        return form;
      },
    },
  },
  methods: {
    input() {
      let form = {};
      const vm = this;
      vm.form.forEach(({ key, value }) => {
        form[key] = value;
      });
      vm.$emit("input", form);
    },
  },
  mounted() {},
};
</script>

<style></style>
